/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {BundlingSettingsTabsComponent} from './bundling-settings-tabs.component';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TooltipModule} from '../../../../shared/tooltip/tooltip.module';

@NgModule({
    declarations: [BundlingSettingsTabsComponent],
    imports: [
        CommonModule,
        TooltipModule
    ],
    exports: [BundlingSettingsTabsComponent]
})
export class BundlingSettingsTabsComponentModule {
}
